import $ from 'jquery';
import ko from 'knockout';
import _ from 'lodash';

export function loadTemplatesAndApplyBindings() {
  $(() => {
    $.ajax('common-templates.html', {})
        .success(function (contents) {

          //Append the template contents to the target element
          $('body').append(contents);

          //http://knockoutjs.com/documentation/deferred-updates.html
          ko.options.deferUpdates = true;

          ko.applyBindings(null);
        }
    );
  });
}